// extracted by mini-css-extract-plugin
module.exports = {"contactTextContainer":"contact-module--contact-text-container--1Jlg-","formContainer":"contact-module--form-container--iw9CG"};